module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/img/finish.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("电子签名完成，请返回电脑端继续操作！")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc9d0d38"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/success.vue
// module id = 508
// module chunks = 1